/**
 * Additional Vocabulary - Round 2
 * 额外词汇 - 第二轮（完成剩余词汇）
 * Target: Complete 186 words total
 */

import { VocabularyWord } from './vocabulary';

export const additionalVocabularyRound2: VocabularyWord[] = [
  // ==================== 补充各类别词汇 ====================

  // 身体部位补充（20词）
  {
    id: 'add-body-1',
    word: 'finger',
    phoneticUS: '/ˈfɪŋɡər/',
    phoneticUK: '/ˈfɪŋɡə/',
    meaning: '手指',
    example: 'I have ten fingers.',
    exampleTranslation: '我有十个手指。',
    category: 'body',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '✋'
  },
  {
    id: 'add-body-2',
    word: 'toe',
    phoneticUS: '/toʊ/',
    phoneticUK: '/təʊ/',
    meaning: '脚趾',
    example: 'I hurt my toe.',
    exampleTranslation: '我弄伤了脚趾。',
    category: 'body',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🦶'
  },
  {
    id: 'add-body-3',
    word: 'knee',
    phoneticUS: '/niː/',
    phoneticUK: '/niː/',
    meaning: '膝盖',
    example: 'I fell on my knee.',
    exampleTranslation: '我摔倒了膝盖。',
    category: 'body',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '🦵'
  },
  {
    id: 'add-body-4',
    word: 'shoulder',
    phoneticUS: '/ˈʃoʊldər/',
    phoneticUK: '/ˈʃəʊldə/',
    meaning: '肩膀',
    example: 'She has a shoulder bag.',
    exampleTranslation: '她有个单肩包。',
    category: 'body',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '🤷'
  },
  {
    id: 'add-body-5',
    word: 'elbow',
    phoneticUS: '/ˈelboʊ/',
    phoneticUK: '/ˈelbəʊ/',
    meaning: '手肘',
    example: 'Don\'t put your elbows on the table.',
    exampleTranslation: '不要把手肘放在桌子上。',
    category: 'body',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '💪'
  },
  {
    id: 'add-body-6',
    word: 'wrist',
    phoneticUS: '/rɪst/',
    phoneticUK: '/rɪst/',
    meaning: '手腕',
    example: 'She wears a watch on her wrist.',
    exampleTranslation: '她手腕上戴着表。',
    category: 'body',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '⌚'
  },
  {
    id: 'add-body-7',
    word: 'ankle',
    phoneticUS: '/ˈæŋkl/',
    phoneticUK: '/ˈæŋkl/',
    meaning: '脚踝',
    example: 'He hurt his ankle.',
    exampleTranslation: '他伤了脚踝。',
    category: 'body',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🦶'
  },
  {
    id: 'add-body-8',
    word: 'forehead',
    phoneticUS: '/ˈfɔːrhed/',
    phoneticUK: '/ˈfɔːhed/',
    meaning: '前额',
    example: 'She touched her forehead.',
    exampleTranslation: '她摸了摸前额。',
    category: 'body',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '👤'
  },
  {
    id: 'add-body-9',
    word: 'chin',
    phoneticUS: '/tʃɪn/',
    phoneticUK: '/tʃɪn/',
    meaning: '下巴',
    example: 'He has a strong chin.',
    exampleTranslation: '他下巴很硬朗。',
    category: 'body',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '😊'
  },
  {
    id: 'add-body-10',
    word: 'cheek',
    phoneticUS: '/tʃiːk/',
    phoneticUK: '/tʃiːk/',
    meaning: '脸颊',
    example: 'Her cheeks are red.',
    exampleTranslation: '她的脸颊红了。',
    category: 'body',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '😊'
  },
  {
    id: 'add-body-11',
    word: 'neck',
    phoneticUS: '/nek/',
    phoneticUK: '/nek/',
    meaning: '脖子',
    example: 'She wears a scarf around her neck.',
    exampleTranslation: '她脖子上围着围巾。',
    category: 'body',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '🧣'
  },
  {
    id: 'add-body-12',
    word: 'tongue',
    phoneticUS: '/tʌŋ/',
    phoneticUK: '/tʌŋ/',
    meaning: '舌头',
    example: 'We use our tongue to taste.',
    exampleTranslation: '我们用舌头品尝味道。',
    category: 'body',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '👅'
  },
  {
    id: 'add-body-13',
    word: 'tooth',
    phoneticUS: '/tuːθ/',
    phoneticUK: '/tuːθ/',
    meaning: '牙齿',
    example: 'I brush my teeth.',
    exampleTranslation: '我刷牙。',
    category: 'body',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🦷'
  },
  {
    id: 'add-body-14',
    word: 'lip',
    phoneticUS: '/lɪp/',
    phoneticUK: '/lɪp/',
    meaning: '嘴唇',
    example: 'She has red lips.',
    exampleTranslation: '她的嘴唇是红色的。',
    category: 'body',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '👄'
  },
  {
    id: 'add-body-15',
    word: 'thumb',
    phoneticUS: '/θʌm/',
    phoneticUK: '/θʌm/',
    meaning: '大拇指',
    example: 'I hurt my thumb.',
    exampleTranslation: '我弄伤了大拇指。',
    category: 'body',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '👍'
  },
  {
    id: 'add-body-16',
    word: 'fist',
    phoneticUS: '/fɪst/',
    phoneticUK: '/fɪst/',
    meaning: '拳头',
    example: 'He made a fist.',
    exampleTranslation: '他握紧了拳头。',
    category: 'body',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '✊'
  },
  {
    id: 'add-body-17',
    word: 'palm',
    phoneticUS: '/pɑːm/',
    phoneticUK: '/pɑːm/',
    meaning: '手掌',
    example: 'She held it in her palm.',
    exampleTranslation: '她把它握在手心里。',
    category: 'body',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '✋'
  },
  {
    id: 'add-body-18',
    word: 'muscle',
    phoneticUS: '/ˈmʌsl/',
    phoneticUK: '/ˈmʌsl/',
    meaning: '肌肉',
    example: 'Exercise builds muscles.',
    exampleTranslation: '锻炼能增强肌肉。',
    category: 'body',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    image: '💪'
  },
  {
    id: 'add-body-19',
    word: 'bone',
    phoneticUS: '/boʊn/',
    phoneticUK: '/bəʊn/',
    meaning: '骨头',
    example: 'Dogs like to chew bones.',
    exampleTranslation: '狗喜欢啃骨头。',
    category: 'body',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🦴'
  },
  {
    id: 'add-body-20',
    word: 'skin',
    phoneticUS: '/skɪn/',
    phoneticUK: '/skɪn/',
    meaning: '皮肤',
    example: 'Her skin is soft.',
    exampleTranslation: '她的皮肤很柔软。',
    category: 'body',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🤚'
  },

  // 服装补充（20词）
  {
    id: 'add-clothes-1',
    word: 'jacket',
    phoneticUS: '/ˈdʒækɪt/',
    phoneticUK: '/ˈdʒækɪt/',
    meaning: '夹克',
    example: 'Put on your jacket.',
    exampleTranslation: '穿上你的夹克。',
    category: 'clothes',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🧥'
  },
  {
    id: 'add-clothes-2',
    word: 'coat',
    phoneticUS: '/koʊt/',
    phoneticUK: '/kəʊt/',
    meaning: '外套',
    example: 'It is cold. Wear a coat.',
    exampleTranslation: '天气冷，穿件外套。',
    category: 'clothes',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🧥'
  },
  {
    id: 'add-clothes-3',
    word: 'sweater',
    phoneticUS: '/ˈswetər/',
    phoneticUK: '/ˈswetə/',
    meaning: '毛衣',
    example: 'This sweater is warm.',
    exampleTranslation: '这件毛衣很暖和。',
    category: 'clothes',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '🧶'
  },
  {
    id: 'add-clothes-4',
    word: 'blouse',
    phoneticUS: '/blaʊz/',
    phoneticUK: '/blaʊz/',
    meaning: '女衬衫',
    example: 'She wears a white blouse.',
    exampleTranslation: '她穿着白色女衬衫。',
    category: 'clothes',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '👚'
  },
  {
    id: 'add-clothes-5',
    word: 'skirt',
    phoneticUS: '/skɜːrt/',
    phoneticUK: '/skɜːt/',
    meaning: '裙子',
    example: 'She likes to wear skirts.',
    exampleTranslation: '她喜欢穿裙子。',
    category: 'clothes',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '👗'
  },
  {
    id: 'add-clothes-6',
    word: 'trousers',
    phoneticUS: '/ˈtraʊzərz/',
    phoneticUK: '/ˈtraʊzəz/',
    meaning: '长裤（英式）',
    example: 'These trousers are too long.',
    exampleTranslation: '这条裤子太长了。',
    category: 'clothes',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '👖'
  },
  {
    id: 'add-clothes-7',
    word: 'shorts',
    phoneticUS: '/ʃɔːrts/',
    phoneticUK: '/ʃɔːts/',
    meaning: '短裤',
    example: 'I wear shorts in summer.',
    exampleTranslation: '夏天我穿短裤。',
    category: 'clothes',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🩳'
  },
  {
    id: 'add-clothes-8',
    word: 'pajamas',
    phoneticUS: '/pəˈdʒæməz/',
    phoneticUK: '/pəˈdʒɑːməz/',
    meaning: '睡衣',
    example: 'Put on your pajamas.',
    exampleTranslation: '穿上你的睡衣。',
    category: 'clothes',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '🛌'
  },
  {
    id: 'add-clothes-9',
    word: 'suit',
    phoneticUS: '/suːt/',
    phoneticUK: '/suːt/',
    meaning: '西装',
    example: 'He wears a suit to work.',
    exampleTranslation: '他穿西装上班。',
    category: 'clothes',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    image: '🤵'
  },
  {
    id: 'add-clothes-10',
    word: 'uniform',
    phoneticUS: '/ˈjuːnɪfɔːrm/',
    phoneticUK: '/ˈjuːnɪfɔːm/',
    meaning: '制服',
    example: 'Students wear uniforms.',
    exampleTranslation: '学生们穿制服。',
    category: 'clothes',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '👔'
  },
  {
    id: 'add-clothes-11',
    word: 'scarf',
    phoneticUS: '/skɑːrf/',
    phoneticUK: '/skɑːf/',
    meaning: '围巾',
    example: 'Wear a scarf in winter.',
    exampleTranslation: '冬天戴围巾。',
    category: 'clothes',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '🧣'
  },
  {
    id: 'add-clothes-12',
    word: 'gloves',
    phoneticUS: '/ɡlʌvz/',
    phoneticUK: '/ɡlʌvz/',
    meaning: '手套',
    example: 'I wear gloves in winter.',
    exampleTranslation: '冬天我戴手套。',
    category: 'clothes',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '🧤'
  },
  {
    id: 'add-clothes-13',
    word: 'hat',
    phoneticUS: '/hæt/',
    phoneticUK: '/hæt/',
    meaning: '帽子',
    example: 'Take off your hat.',
    exampleTranslation: '脱下你的帽子。',
    category: 'clothes',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🎩'
  },
  {
    id: 'add-clothes-14',
    word: 'cap',
    phoneticUS: '/kæp/',
    phoneticUK: '/kæp/',
    meaning: '鸭舌帽',
    example: 'He wears a baseball cap.',
    exampleTranslation: '他戴着棒球帽。',
    category: 'clothes',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🧢'
  },
  {
    id: 'add-clothes-15',
    word: 'sock',
    phoneticUS: '/sɑːk/',
    phoneticUK: '/sɒk/',
    meaning: '袜子',
    example: 'I need new socks.',
    exampleTranslation: '我需要新袜子。',
    category: 'clothes',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🧦'
  },
  {
    id: 'add-clothes-16',
    word: 'belt',
    phoneticUS: '/belt/',
    phoneticUK: '/belt/',
    meaning: '皮带',
    example: 'He wears a belt.',
    exampleTranslation: '他系着皮带。',
    category: 'clothes',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '🔗'
  },
  {
    id: 'add-clothes-17',
    word: 'tie',
    phoneticUS: '/taɪ/',
    phoneticUK: '/taɪ/',
    meaning: '领带',
    example: 'He wears a tie.',
    exampleTranslation: '他戴着领带。',
    category: 'clothes',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '👔'
  },
  {
    id: 'add-clothes-18',
    word: 'button',
    phoneticUS: '/ˈbʌtn/',
    phoneticUK: '/ˈbʌtn/',
    meaning: '纽扣',
    example: 'Button your shirt.',
    exampleTranslation: '扣上你的衬衫扣子。',
    category: 'clothes',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '🔘'
  },
  {
    id: 'add-clothes-19',
    word: 'pocket',
    phoneticUS: '/ˈpɑːkɪt/',
    phoneticUK: '/ˈpɒkɪt/',
    meaning: '口袋',
    example: 'Put it in your pocket.',
    exampleTranslation: '把它放在口袋里。',
    category: 'clothes',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '🥿'
  },
  {
    id: 'add-clothes-20',
    word: 'zipper',
    phoneticUS: '/ˈzɪpər/',
    phoneticUK: '/ˈzɪpə/',
    meaning: '拉链',
    example: 'The zipper is broken.',
    exampleTranslation: '拉链坏了。',
    category: 'clothes',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🔗'
  },

  // 动作动词补充（26词）
  {
    id: 'add-action-1',
    word: 'climb',
    phoneticUS: '/klaɪm/',
    phoneticUK: '/klaɪm/',
    meaning: '爬',
    example: 'I can climb the tree.',
    exampleTranslation: '我会爬树。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🧗'
  },
  {
    id: 'add-action-2',
    word: 'jump',
    phoneticUS: '/dʒʌmp/',
    phoneticUK: '/dʒʌmp/',
    meaning: '跳',
    example: 'Can you jump high?',
    exampleTranslation: '你能跳得高吗？',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🦘'
  },
  {
    id: 'add-action-3',
    word: 'kick',
    phoneticUS: '/kɪk/',
    phoneticUK: '/kɪk/',
    meaning: '踢',
    example: 'Don\'t kick the ball.',
    exampleTranslation: '不要踢球。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '⚽'
  },
  {
    id: 'add-action-4',
    word: 'throw',
    phoneticUS: '/θroʊ/',
    phoneticUK: '/θrəʊ/',
    meaning: '扔',
    example: 'Throw the ball to me.',
    exampleTranslation: '把球扔给我。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🏀'
  },
  {
    id: 'add-action-5',
    word: 'catch',
    phoneticUS: '/kætʃ/',
    phoneticUK: '/kætʃ/',
    meaning: '接住',
    example: 'Can you catch the ball?',
    exampleTranslation: '你能接住球吗？',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🧤'
  },
  {
    id: 'add-action-6',
    word: 'push',
    phoneticUS: '/pʊʃ/',
    phoneticUK: '/pʊʃ/',
    meaning: '推',
    example: 'Push the door.',
    exampleTranslation: '推门。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🚪'
  },
  {
    id: 'add-action-7',
    word: 'pull',
    phoneticUS: '/pʊl/',
    phoneticUK: '/pʊl/',
    meaning: '拉',
    example: 'Pull the door open.',
    exampleTranslation: '把门拉开。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🚪'
  },
  {
    id: 'add-action-8',
    word: 'carry',
    phoneticUS: '/ˈkæri/',
    phoneticUK: '/ˈkæri/',
    meaning: '搬运',
    example: 'Can you carry this box?',
    exampleTranslation: '你能搬这个箱子吗？',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '📦'
  },
  {
    id: 'add-action-9',
    word: 'hold',
    phoneticUS: '/hoʊld/',
    phoneticUK: '/həʊld/',
    meaning: '拿住',
    example: 'Hold my hand.',
    exampleTranslation: '握住我的手。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🤝'
  },
  {
    id: 'add-action-10',
    word: 'drop',
    phoneticUS: '/drɑːp/',
    phoneticUK: '/drɒp/',
    meaning: '掉下',
    example: 'Don\'t drop the glass.',
    exampleTranslation: '不要把杯子摔了。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '💧'
  },
  {
    id: 'add-action-11',
    word: 'pick',
    phoneticUS: '/pɪk/',
    phoneticUK: '/pɪk/',
    meaning: '挑选',
    example: 'Pick a number.',
    exampleTranslation: '选一个数字。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '👆'
  },
  {
    id: 'add-action-12',
    word: 'build',
    phoneticUS: '/bɪld/',
    phoneticUK: '/bɪld/',
    meaning: '建造',
    example: 'Let\'s build a castle.',
    exampleTranslation: '我们建一座城堡吧。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '🏰'
  },
  {
    id: 'add-action-13',
    word: 'break',
    phoneticUS: '/breɪk/',
    phoneticUK: '/breɪk/',
    meaning: '打破',
    example: 'Don\'t break the toy.',
    exampleTranslation: '不要弄坏玩具。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '💔'
  },
  {
    id: 'add-action-14',
    word: 'fix',
    phoneticUS: '/fɪks/',
    phoneticUK: '/fɪks/',
    meaning: '修理',
    example: 'Can you fix this?',
    exampleTranslation: '你能修好这个吗？',
    category: 'actions',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🔧'
  },
  {
    id: 'add-action-15',
    word: 'cut',
    phoneticUS: '/kʌt/',
    phoneticUK: '/kʌt/',
    meaning: '切',
    example: 'Cut the paper.',
    exampleTranslation: '剪纸。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '✂️'
  },
  {
    id: 'add-action-16',
    word: 'fold',
    phoneticUS: '/foʊld/',
    phoneticUK: '/fəʊld/',
    meaning: '折叠',
    example: 'Fold the paper.',
    exampleTranslation: '折叠纸张。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '📄'
  },
  {
    id: 'add-action-17',
    word: 'draw',
    phoneticUS: '/drɔː/',
    phoneticUK: '/drɔː/',
    meaning: '画画',
    example: 'I like to draw.',
    exampleTranslation: '我喜欢画画。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🎨'
  },
  {
    id: 'add-action-18',
    word: 'paint',
    phoneticUS: '/peɪnt/',
    phoneticUK: '/peɪnt/',
    meaning: '绘画',
    example: 'She paints beautiful pictures.',
    exampleTranslation: '她画美丽的画。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '🖼️'
  },
  {
    id: 'add-action-19',
    word: 'sing',
    phoneticUS: '/sɪŋ/',
    phoneticUK: '/sɪŋ/',
    meaning: '唱歌',
    example: 'I can sing a song.',
    exampleTranslation: '我会唱歌。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🎤'
  },
  {
    id: 'add-action-20',
    word: 'dance',
    phoneticUS: '/dæns/',
    phoneticUK: '/dɑːns/',
    meaning: '跳舞',
    example: 'Let\'s dance together.',
    exampleTranslation: '我们一起跳舞吧。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '💃'
  },
  {
    id: 'add-action-21',
    word: 'cook',
    phoneticUS: '/kʊk/',
    phoneticUK: '/kʊk/',
    meaning: '做饭',
    example: 'My mom cooks dinner.',
    exampleTranslation: '我妈妈做晚饭。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '👨‍🍳'
  },
  {
    id: 'add-action-22',
    word: 'bake',
    phoneticUS: '/beɪk/',
    phoneticUK: '/beɪk/',
    meaning: '烘烤',
    example: 'We bake cookies.',
    exampleTranslation: '我们烤饼干。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '🍪'
  },
  {
    id: 'add-action-23',
    word: 'wash',
    phoneticUS: '/wɑːʃ/',
    phoneticUK: '/wɒʃ/',
    meaning: '洗',
    example: 'Wash your hands.',
    exampleTranslation: '洗手。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🧼'
  },
  {
    id: 'add-action-24',
    word: 'clean',
    phoneticUS: '/kliːn/',
    phoneticUK: '/kliːn/',
    meaning: '打扫',
    example: 'Clean your room.',
    exampleTranslation: '打扫你的房间。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🧹'
  },
  {
    id: 'add-action-25',
    word: 'iron',
    phoneticUS: '/ˈaɪərn/',
    phoneticUK: '/ˈaɪən/',
    meaning: '熨烫',
    example: 'Iron the shirt.',
    exampleTranslation: '熨衬衫。',
    category: 'actions',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '👔'
  },
  {
    id: 'add-action-26',
    word: 'sweep',
    phoneticUS: '/swiːp/',
    phoneticUK: '/swiːp/',
    meaning: '扫地',
    example: 'Sweep the floor.',
    exampleTranslation: '扫地。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '🧹'
  }
];
